import React, { forwardRef } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Slide from '@material-ui/core/Slide';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import Close from '@material-ui/icons/Close';
import Button from '@/components/common/ui/Button';
import styles from 'styles/jss/original/components/favorites/favoriteMenuModal';
import classNames from 'classnames';
import FavoriteMenuModalList from '@/components/favorites/FavoriteMenuModalList';
import { IMenu } from '@/@types/generated/contentful';

// @ts-expect-error
const useStyles = makeStyles(styles);

type ComponentProps = {
  menuList: IMenu[];
  isOpen: boolean;
  onClose: () => void;
};

const Transition = forwardRef(function Transition(props, ref) {
  // @ts-expect-error タイプ '{ children? ReactNode; direction: "down"; ref: ForwardedRef<unknown>; }' はタイプ 'SlideProps' に割り当てることができません。
  return <Slide direction='down' ref={ref} {...props} />;
});
Transition.displayName = 'Transition';

const FavoriteMenuModal: React.FC<ComponentProps> = ({ menuList, isOpen, onClose }) => {
  const classes = useStyles();
  return (
    <>
      <Dialog
        classes={{
          root: classes.modalRoot,
          paper: classes.modal
        }}
        open={isOpen}
        // @ts-expect-error
        TransitionComponent={Transition}
        keepMounted
        onClose={onClose}
        aria-labelledby='classic-modal-slide-title'
        aria-describedby='classic-modal-slide-description'
      >
        <DialogTitle
          id='classic-modal-slide-title'
          disableTypography
          className={classes.modalHeader}
        >
          <Button
            simple
            color='gray'
            className={classes.modalCloseButton}
            key='close'
            aria-label='Close'
            onClick={onClose}
          >
            {' '}
            <Close className={classes.modalClose} />
          </Button>
          <h4 className={classes.modalTitle}>食材一覧</h4>
        </DialogTitle>
        <DialogContent id='classic-modal-slide-description' className={classes.modalBody}>
          {menuList.map((item, index) => (
            <div key={`menu-item-${index.toString()}`}>
              <FavoriteMenuModalList menu={item} />
            </div>
          ))}
        </DialogContent>
        <DialogActions className={classes.modalFooter}>
          <Button
            onClick={onClose}
            simple
            color='gray'
            className={classNames(classes.description, classes.closeButton)}
          >
            閉じる
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default FavoriteMenuModal;
